import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { MdDeleteForever } from "react-icons/md";
import { useSelector } from "react-redux";
import { api, endpoint } from "../../api";

const LayoutCounter = ({ data, mode, handlerRemove, handlerUpdate }) => {
  const { userDetails } = useSelector((state) => state.user);


  const { chartTitle, locations, unit } = data
  const [value, setValue] = useState({})

  const getDial = async () => {
    const { result, success } = await api.get(endpoint.dial, {
      params: {
        yAxis: locations[0].yAxis
      }
    })
    if (success) {
      console.log({ result, locations })
      setValue(result)
    }
  }

  useEffect(() => {
    getDial()
  }, [])

  return (
    <div className="p-4">
      {userDetails.role === "superAdmin" && <div className="d-flex justify-content-end align-items-center">
        {
          mode === 'view' ? '' : (<>
            <div className="clickbtn" onClick={() => handlerUpdate(data._id)}>
              <FiEdit className="text-secondary me-1" />
            </div>
            <div className="clickbtn" onClick={() => handlerRemove(data._id)}>
              <MdDeleteForever className="fs-5 text-secondary" />
            </div>
          </>)
        }
      </div>}
      <div className="mt-5 border p-2 text-center bg-success text-white">
        <h3>{chartTitle}</h3>
        <h2>{value?.value ? Number(value.value).toFixed(2) : 0}</h2>
        <strong>{unit}</strong>
      </div>
    </div>
  );
};

export default LayoutCounter;
